/**
 * Help Center page — route: /help.
 *
 * Three stacked sections:
 *   1. ChatActivationPanel    — entry point to the bot (Plan C wires it live)
 *   2. FAQAccordion           — static Q&A (no API cost)
 *   3. ContactSection         — email + phone fallback
 *
 * Header is provided by PortalHeader (shared). The Help button in PortalHeader
 * routes here, so this page does not render a second header.
 */

import { Link } from 'react-router-dom';
import { PortalHeader } from '../Layout/PortalHeader';
import { ChatActivationPanel } from './ChatActivationPanel';
import { FAQAccordion } from './FAQAccordion';
import { ContactSection } from './ContactSection';
import './HelpCenter.css';

export function HelpCenter() {
  return (
    <div className="help-center-root">
      <PortalHeader showCredits={false} />
      <div className="container help-center-container">
        <div className="help-center-breadcrumb">
          <Link to="/">← Back to Dashboard</Link>
          <h1 className="help-center-page-title">Help Center</h1>
        </div>

        <ChatActivationPanel />

        <div className="help-center-divider" />

        <section className="help-faq-section">
          <h2 className="help-faq-title">📘 Frequently Asked Questions</h2>
          <FAQAccordion />
        </section>

        <div className="help-center-divider" />

        <ContactSection />
      </div>
    </div>
  );
}
